/**
 * earthtech — AK-321 v1.1. Резолв Earth Tech accent-brand (amber) для
 * terra-draw styling.
 *
 * Terra-draw, как и MapLibre paint, принимает hex/rgb-строки, а НЕ CSS var().
 * Поэтому читаем computed-значение токена `--accent-brand` в рантайме (тот же
 * приём, что в MeasureController #365 / pillSprite #359) и конвертируем в hex
 * (terra-draw HexColor требует `#rrggbb`). Фолбэк — задокументированная
 * Earth Tech amber-константа, консистентная с measure-оверлеем.
 */

/** Earth Tech --palette-accent-500 ≈ #F4A300 (консистентно с MeasureController). */
export const AMBER_HEX_FALLBACK = '#f4a300';

/** Белый для вершинных точек (как measure-vertices). */
export const VERTEX_WHITE = '#ffffff';

/**
 * Резолвит accent-brand в hex-строку `#rrggbb`. Terra-draw НЕ принимает
 * rgb()/hsl(), только hex — поэтому конвертируем computed color.
 */
export function resolveAmberHex(): `#${string}` {
  if (typeof document === 'undefined') return AMBER_HEX_FALLBACK as `#${string}`;
  const probe = document.createElement('span');
  probe.style.cssText = 'position:absolute;left:-9999px;top:-9999px;color:hsl(var(--accent-brand));';
  document.body.appendChild(probe);
  try {
    const computed = getComputedStyle(probe).color; // «rgb(r, g, b)»
    return rgbToHex(computed) ?? (AMBER_HEX_FALLBACK as `#${string}`);
  } catch {
    return AMBER_HEX_FALLBACK as `#${string}`;
  } finally {
    probe.remove();
  }
}

/** «rgb(244, 163, 0)» → «#f4a300». Возвращает null если не распарсилось. */
function rgbToHex(rgb: string): `#${string}` | null {
  const m = rgb.match(/rg(?:b|ba)?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
  if (!m) return null;
  const h = (n: number) => n.toString(16).padStart(2, '0');
  return `#${h(+m[1])}${h(+m[2])}${h(+m[3])}` as `#${string}`;
}
